var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirefighter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 492.72 492.72",
    style: {
      enableBackground: "new 0 0 492.72 492.72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF1008"
    },
    d: "M380.488,194.72c0,65.008-60.048,48.592-134.128,48.592s-134.128,16.416-134.128-48.592 S172.28,51.088,246.36,51.088S380.488,129.712,380.488,194.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#820B0B"
    },
    d: "M380.488,194.72c0,65.008-60.048,152.272-134.128,152.272S112.232,259.728,112.232,194.72 S172.28,94.288,246.36,94.288S380.488,129.712,380.488,194.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#680202"
    },
    d: "M380.488,194.72c0,65.008-60.048,117.704-134.128,117.704S112.232,259.728,112.232,194.72 S172.28,94.288,246.36,94.288S380.488,129.712,380.488,194.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C0000"
    },
    d: "M380.488,194.72c0,65.008-60.048,83.16-134.128,83.16s-134.128-18.152-134.128-83.16 S172.28,94.288,246.36,94.288S380.488,129.712,380.488,194.72z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "304.152,300.72 188.536,300.72 196.256,204.72 296.448,204.72 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E28F71"
    },
    points: "304.152,300.72 246.16,300.72 188.536,204.72 296.448,204.72 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCCCB9"
    },
    d: "M324.408,132.008c0,67.904-34.216,129.336-78.048,129.336c-43.84,0-78.048-61.432-78.048-129.336 S202.52,52.8,246.36,52.8C290.192,52.8,324.408,64.096,324.408,132.008z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BDA0"
    },
    d: "M246.36,52.8c43.832,0,78.048,11.304,78.048,79.208s-34.216,129.336-78.048,129.336"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EFA78B"
    },
    cx: 247.4,
    cy: 132.288,
    rx: 80.48,
    ry: 33.312
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8790A"
    },
    d: "M181.296,102.28c0,0-0.64,23.952-6.704,23.952l-4.472,4.464c0,0,0.952,29.056,2.552,30.336 c1.6,1.288-4.464,3.52-6.384-12.128c-1.912-15.656-2.872-49.816-2.872-49.816L181.296,102.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8790A"
    },
    d: "M311.424,102.28c0,0,0.64,23.952,6.704,23.952l4.472,4.464c0,0-0.952,29.056-2.552,30.336 c-1.6,1.288,4.464,3.52,6.384-12.128c1.912-15.656,2.872-49.816,2.872-49.816L311.424,102.28z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D82727"
    },
    points: "456.272,328.72 340.744,288.136 329.016,287.168 308.176,266.032 247.408,304.424  186.648,265.912 164.616,284.96 153.824,286.888 36.448,328.72 14.36,492.72 193.96,492.72 239.496,492.72 253.224,492.72  300.864,492.72 478.36,492.72 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#BF1008"
    },
    points: "86.36,492.72 239.496,492.72 253.224,492.72 300.864,492.72 478.36,492.72 456.272,328.72  340.744,288.136 321.352,285.728 308.176,266.032 247.408,304.424 186.648,265.912 247.52,304.44 153.824,286.888 37.616,328.72 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#820B0B"
    },
    points: "247.016,305.584 307.976,266.496 312.624,288.128 340.696,287.672 456.248,328.792  478.36,492.72 300.864,492.72 253.224,492.72 246.36,492.72 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#4C0000"
    },
    points: "398.36,492.72 478.36,492.72 456.8,329.952 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D3AE11"
    },
    cx: 246.36,
    cy: 368.32,
    r: 5.264
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D3AE11"
    },
    cx: 246.36,
    cy: 407.12,
    r: 5.264
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D82727"
    },
    d: "M345.624,93.344c0,29.504-48.68,25.248-99.264,25.248c-50.6,0-99.264,4.256-99.264-25.248 c0-29.512,48.664-75.176,99.264-75.176C296.944,18.16,345.624,63.832,345.624,93.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF1008"
    },
    d: "M246.36,18.16c50.584,0,99.264,45.664,99.264,75.176c0,29.504-48.68,25.248-99.264,25.248 c-50.6,0-99.264,4.256-99.264-25.248"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#820B0B"
    },
    d: "M246.36,18.16c50.584,0,99.264,45.664,99.264,75.176c0,29.504-48.68,25.248-99.264,25.248"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D82727"
    },
    d: "M331.616,113.744c0,4.952-38.168,16.952-85.256,16.952c-47.104,0-85.272-12-85.272-16.952 s38.168-31.968,85.272-31.968C293.456,81.776,331.616,108.792,331.616,113.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF1008"
    },
    d: "M331.616,113.744c0,4.952-38.168,16.952-85.256,16.952c-47.104,0-85.272-12-85.272-16.952 s38.168-8.968,85.272-8.968C293.456,104.776,331.616,108.792,331.616,113.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#820B0B"
    },
    d: "M331.616,113.744c0,4.952-38.168,16.952-85.256,16.952c-47.104,0-85.272-12-85.272-16.952 s38.168,6.36,85.272,6.36C293.456,120.104,331.616,108.792,331.616,113.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D82727"
    },
    d: "M186.648,398.632c0,1.592-1.296,2.872-2.872,2.872H92.432c-1.6,0-2.88-1.288-2.88-2.872l0,0 c0-1.584,1.288-2.88,2.88-2.88h91.336C185.352,395.752,186.648,397.048,186.648,398.632L186.648,398.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C0000"
    },
    d: "M403.16,398.632c0,1.592-1.288,2.872-2.864,2.872h-91.344c-1.6,0-2.888-1.288-2.888-2.872l0,0 c0-1.584,1.296-2.88,2.888-2.88h91.336C401.872,395.752,403.16,397.048,403.16,398.632L403.16,398.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D82727"
    },
    d: "M186.648,413.96c0,1.584-1.296,2.872-2.872,2.872H92.432c-1.6,0-2.88-1.288-2.88-2.872l0,0 c0-1.584,1.288-2.872,2.88-2.872h91.336C185.352,411.088,186.648,412.376,186.648,413.96L186.648,413.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C0000"
    },
    d: "M403.16,413.96c0,1.584-1.288,2.872-2.864,2.872h-91.344c-1.6,0-2.888-1.288-2.888-2.872l0,0 c0-1.584,1.296-2.872,2.888-2.872h91.336C401.872,411.088,403.16,412.376,403.16,413.96L403.16,413.96z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#820B0B"
    },
    points: "232.696,84.72 220.92,47.2 251.744,16.488 282.584,47.52 270.808,84.72 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE266"
    },
    points: "227.312,68.72 215.528,30.872 246.36,0 277.192,31.272 265.416,68.72 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E8C42D"
    },
    points: "227.312,68.72 215.528,30.872 246.36,35.128 277.192,31.272 265.416,68.72 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D3AE11"
    },
    points: "227.312,68.72 245.184,51.736 246.36,0 277.192,31.272 265.416,68.72 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#820B0B"
    },
    points: "245.968,489.864 147.288,287.72 113.752,333.704 155.904,345.2 132.92,390.232 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4C0000"
    },
    points: "246.752,489.864 345.432,287.72 378.968,333.704 336.816,345.2 359.8,390.232 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F73434"
    },
    d: "M327.792,292.72c0,16.664-13.504,32-30.176,32H195.104c-16.664,0-30.184-15.336-30.184-32l0,0 c0-16.672-1.808-32,14.864-32h133.16C329.616,260.72,327.792,276.048,327.792,292.72L327.792,292.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF1008"
    },
    d: "M327.792,294.24c0,16.664-13.504,30.48-30.176,30.48H195.104c-16.664,0-30.184-13.808-30.184-30.48 l0,0c0-16.672-1.808-20.264,14.864-20.264l133.16-9.984C329.616,263.992,327.792,277.568,327.792,294.24L327.792,294.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#820B0B"
    },
    d: "M327.808,293.944c0,16.664-17.312,45.504-32.328,45.504l-87.288-15.328 C190.904,319.968,181,310.608,181,293.944l0,0c0-16.672-1.648-14.848,13.376-14.848l120.04-7.664 C329.432,271.432,327.808,277.272,327.808,293.944L327.808,293.944z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D3AE11"
    },
    cx: 208.04,
    cy: 297.544,
    r: 10.776
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B77909"
    },
    d: "M200.448,289.92c4.2-4.224,11.024-4.208,15.232,0s4.216,11.024,0,15.24"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#350101"
    },
    d: "M326.36,473.888c0,5.984-4.848,10.832-10.832,10.832H177.192c-5.984,0-10.832-4.848-10.832-10.832 V455.56c0-5.992,4.848-10.84,10.832-10.84H315.52c5.992,0,10.84,4.848,10.84,10.832V473.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F0000"
    },
    d: "M326.36,460.72v18.688c0,5.984-7.256,13.312-13.24,13.312H179.592 c-5.992,0-13.232-7.328-13.232-13.312V460.72"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 214.84,
    cy: 470,
    r: 2.632
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 198.84,
    cy: 470,
    r: 2.632
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 228.016,
    cy: 470,
    r: 2.64
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 241.184,
    cy: 470,
    r: 2.632
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 254.36,
    cy: 470,
    r: 2.64
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 267.528,
    cy: 470,
    r: 2.632
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 280.68,
    cy: 470,
    r: 2.64
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF1008"
    },
    cx: 293.88,
    cy: 470,
    r: 2.632
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#350101"
    },
    d: "M124.52,302.736c1.024,3.376-15.344,3.728-36.608,10.256c-21.24,6.504-39.288,16.736-40.328,13.36 c-1.032-3.376,15.344-19.064,36.584-25.576C105.416,294.248,123.48,299.376,124.52,302.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#350101"
    },
    d: "M368.2,302.736c-1.024,3.376,15.344,3.728,36.608,10.256c21.24,6.504,39.288,16.736,40.328,13.36 c1.032-3.376-15.344-19.064-36.584-25.576C387.304,294.248,369.24,299.376,368.2,302.736z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D3AE11"
    },
    cx: 246.36,
    cy: 39.048,
    r: 11.016
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B78C04"
    },
    d: "M238.568,31.256c4.296-4.304,11.288-4.296,15.576,0c4.312,4.312,4.304,11.28,0.008,15.576"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefighter);
export default __webpack_public_path__ + "static/media/firefighter.030e97fb029448a0bf8fc7c91694ba3b.svg";
export { ForwardRef as ReactComponent };